import React, { useState } from "react"; 
import { FiTrash, FiMonitor, FiLink2, FiUser, FiKey, FiMessageCircle } from "react-icons/fi"; 
import Button from "../../../../app/components/Button";  

const AccessClient = ({ onOpenAccess, acessList, onDelete = () => {} }) => {   

  return (     
    <div>       
      <Button         
        variant="primary"         
        onClick={onOpenAccess}         
        className="w-full"         
      >         
        Adicionar acesso       
      </Button>       
      
      {acessList.length === 0 ? (
        <div className="text-center text-gray-500 text-sm mt-6">
          <span className="font-medium">Nenhum acesso cadastrado ainda.</span> <br />
          Adicione um acesso para começar.
        </div>
      ) : (
        acessList.map((item) => (
          <div key={item.id} className="relative border mt-8 pl-3 rounded-br-2xl rounded-tr-2xl rounded-tl-2xl pb-4">
            <button
              type="button"
              className="absolute -top-1 -right-1 bg-white p-[0.09rem] text-red-500 text-sm"
              onClick={() => onDelete(item)}
            >
              <FiTrash />
            </button>

            <div className="flex items-center mt-4 gap-2">
              <FiMonitor />
              <h3>Plataforma</h3>
            </div>
            <p className="text-gray-400 mt-1">{item.plataforma}</p>

            <div className="flex items-center mt-4 gap-2">
              <FiLink2 />
              <h3>Link de acesso</h3>
            </div>
            <a
              className="text-gray-400 mt-1 transition-colors duration-300 hover:text-gray-500"
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              {item.link}
            </a>

            <div className="flex items-center mt-4 gap-2">
              <FiUser />
              <h3>Usuário</h3>
            </div>
            <p className="text-gray-400 mt-1">{item.usuario}</p>

            <div className="flex items-center mt-4 gap-2">
              <FiKey />
              <h3>Senha</h3>
            </div>
            <p className="text-gray-400 mt-1">{item.senha}</p>

            <div className="flex items-center mt-4 gap-2">
              <FiMessageCircle />
              <h3>Observações</h3>
            </div>
            <p className="text-gray-400 mt-1">{item.observacao}</p>
          </div>
        ))
      )}
    </div>   
  ); 
};  

export default AccessClient;